import React from 'react'

const RatingStars = ({ rating, setRating, hover, setHover }) => {
  return (
    <div className='jdgm-form__fieldset' aria-label='Rating'>
      <label>Rating</label>
      <span className='jdgm-form__rating' style={{ cursor: 'pointer' }}>
        {[1, 2, 3, 4, 5].map((star) => (
          <a
            key={star}
            data-alt={star}
            className={`jdgm-star ${star <= (hover || rating) ? 'jdgm--on' : 'jdgm--off'}`}
            title={`${star} star${star > 1 ? 's' : ''}`}
            role='button'
            aria-label={`${star} star${star > 1 ? 's' : ''}`}
            onClick={() => setRating(star)}
            onMouseEnter={() => setHover(star)}
            onMouseLeave={() => setHover(0)}
          />
        ))}
        <input name='score' type='hidden' value={rating} />
      </span>
    </div>
  )
}

export default RatingStars
